{
    "StatvaluestypeLabel": "Saída para campos de percentagem, data\/hora e duração:",
    "StatvaluestypeBothOptionLabel": "[Valores duplos (formatados + brutos)]",
    "StatvaluestypeMainOptionLabel": "Apenas valor de apresentação formatado (texto)",
    "StatvaluestypeAlternateOptionLabel": "Apenas valor bruto (para representação gráfica + utilização de fórmula)",
    "CSVExportFormat_SectionHeader": "Formato de exportação CSV \/ XLS",
    "CSVExportFormat_SectionPara": "Pode ajustar a forma como os valores estatísticos de percentagem, data\/hora e duração são gerados nos relatórios CSV e XLS exportados.",
    "NAME": "CSVExportFormat"
}